module.exports = "<footer class=\"footer \">\n  <div class=\"container-fluid\">\n  </div>\n</footer>\n"